import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { useLocation, useNavigate } from "react-router-dom";
import ApplyBtn from "../Components/ApplyBtn";
import MoreBtn from "../Components/MoreBtn";
import Layout from "../Layout/Layout";
import Pagination from "../Layout/Pagination";
import AlarmApply from "../Modals/AlarmApply";
import AlarmSimpleOk from "../Modals/AlarmSimpleOk";
import IssuedGifticonList from "../Modals/IssuedGifticonList";
import "../Styles/component.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";
import { showToast } from "../Utils/variables";

const ChallengeManageContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [challenge_list, setChallenge_list] = useState([]);
  const [total_challenge, setTotal_challenge] = useState(0);

  const [page, setPage] = useState(1);
  const offset = 10;

  const [selectedId, setSelectedId] = useState(-1);
  const [clickRow, setClickRow] = useState(false);

  const [alarmState, setAlarmState] = useState({ show: false, type: "" });
  const lastChallengeRequestKey = useRef(null);

  const getChallengeList = async () => {
    try {
      const res = await postJson(
        "/dashboard/gifticonChallenge/getList",
        { page, offset },
        navigate
      );

      if (res.code === 200) {
        setTotal_challenge(res.data.count);
        setChallenge_list(res.data.rows);
      }
    } catch (error) {
      console.error("챌린지 리스트 가져오기 중 에러:", error);
    }
  };

  const handleClickList = (id) => {
    setClickRow(true);
    setSelectedId(id);
  };

  const deleteChallenge = async () => {
    try {
      const res = await postJson(
        "/dashboard/gifticonChallenge/delete",
        { companyChallengeId: selectedId },
        navigate
      );

      if (res.code === 200) {
        setAlarmState({ show: false, type: "" });
        window.location.reload();
      }
    } catch (error) {
      console.error("챌린지 삭제 중 에러:", error);
    }
  };

  useEffect(() => {
    const requestKey = JSON.stringify({ page });

    if (lastChallengeRequestKey.current === requestKey) {
      return;
    }

    lastChallengeRequestKey.current = requestKey;
    getChallengeList();
  }, [page]);

  useEffect(() => {
    if (location.state?.toast_enable) {
      showToast("우리기업 챌린지가 등록되었습니다.", "success");
      window.history.replaceState({}, document.title);
    }
    if (location.state?.error) {
      setAlarmState({ show: true, type: location.state?.message });
    }
  }, [location.state]);

  return (
    <div>
      {clickRow && (
        <IssuedGifticonList
          handleClickX={() => setClickRow(false)}
          companyChallengeId={selectedId}
        />
      )}
      {alarmState.show && alarmState.type === "delete" ? (
        <AlarmApply
          title="챌린지를 삭제하시겠습니까?"
          subtitle="기간이 종료되지 않은 상태로 삭제 시 지금까지의 기록이 사라지고 앱 화면에서도 내역이 사라집니다."
          handleApply={() => deleteChallenge(selectedId)}
          handleClickX={() => setAlarmState({ show: false, type: "" })}
        />
      ) : alarmState.show && alarmState.type === "갯수초과" ? (
        <AlarmSimpleOk
          title="챌린지 등록 불가"
          description="발급 가능한 기프티콘 갯수를 초과하였습니다."
          handleClickX={() => setAlarmState({ show: false, type: "" })}
        />
      ) : (
        alarmState.show &&
        alarmState.type === "대회중복" && (
          <AlarmSimpleOk
            title="챌린지 등록 불가"
            description={
              <>
                현재 진행전이거나 진행중인 챌린지가 존재하여
                <br />
                등록이 불가능합니다.
              </>
            }
            handleClickX={() => setAlarmState({ show: false, type: "" })}
          />
        )
      )}
      {/* 우리기업 챌린지 관리 박스 */}
      <ChallengeBox>
        <div className="title-in-box">우리기업 챌린지 관리</div>

        <p
          className="bold-text"
          style={{ fontSize: "18px", marginTop: "20px" }}
        >
          우리기업 챌린지란?
        </p>
        <p style={{ fontSize: "14px", color: "#555555", marginTop: "4px" }}>
          일정한 목표 걸음수를 설정하고 달성하는 구성원에게 기프티콘을 선물해요.
          ‘혜택’ 페이지 하단에 위치
        </p>

        {/* 전체 n건 | 등록하기 버튼 */}
        <div
          className="hrz-wrapper"
          style={{ marginTop: "20px", color: "#000000" }}
        >
          전체 {total_challenge}건
          <div style={{ marginLeft: "auto" }}>
            <ApplyBtn addr="/challenge/apply" />
          </div>
        </div>

        {/* 푸시알림 리스트 */}
        <div className="listArea" style={{ marginTop: "10px" }}>
          {/* 라벨 */}
          <div
            className="list_titleBar"
            style={{
              gridTemplateColumns: "100px 220px 100px 200px 180px 700px",
            }}
          >
            <p
              className="center medium-text"
              style={{ fontSize: "14px", color: "#929292" }}
            >
              NO
            </p>
            <p
              className="leftalign medium-text"
              style={{ fontSize: "14px", color: "#929292" }}
            >
              진행 기간
            </p>
            <p
              className="leftalign medium-text"
              style={{ fontSize: "14px", color: "#929292" }}
            >
              진행상태
            </p>
            <p
              className="leftalign medium-text"
              style={{ fontSize: "14px", color: "#929292" }}
            >
              목표 걸음 수
            </p>
            <p
              className="leftalign medium-text"
              style={{ fontSize: "14px", color: "#929292" }}
            >
              누적 발급 기프티콘 수
            </p>
            <p
              className="leftalign medium-text"
              style={{ fontSize: "14px", color: "#929292" }}
            >
              등록일
            </p>
          </div>

          {/* 데이터 */}
          {challenge_list.slice(0, 10).map((data) => (
            <ChallengeData
              key={data.rownum}
              rownum={data.rownum}
              startTime={data.startTime}
              endTime={data.endTime}
              step={data.step}
              gifticonCount={data.issuedCount}
              regTime={data.regTime}
              companyChallengeId={data.companyChallengeId}
              handleClickList={handleClickList}
              handleClickDelete={(id) => {
                setAlarmState({ show: true, type: "delete" });
                setSelectedId(id);
              }}
            />
          ))}
          {/* <ChallengeData
            rownum={1}
            startTime="2024-12-02"
            endTime="2025-01-01"
            step={330000}
            gifticonCount={300}
            regTime="2025-01-01 00:00:00"
            companyChallengeId={1}
            handleClickList={handleClickList}
            handleClickDelete={(id) => {
              setAlarmState({ show: true, type: "delete" });
              setSelectedId(id);
            }}
          /> */}
        </div>

        {/* 페이징 */}
        <Pagination
          totalPages={
            total_challenge === 0 ? 1 : Math.ceil(total_challenge / 10)
          }
          currentPage={page}
          onPageChange={(pageNum) => setPage(pageNum)}
        />
      </ChallengeBox>
    </div>
  );
};

const ChallengeData = ({
  rownum,
  startTime,
  endTime,
  step,
  gifticonCount,
  regTime,
  companyChallengeId,
  handleClickList,
  handleClickDelete,
}) => {
  const today = new Date();

  const start = new Date(startTime.replace(/\./g, "-")); // "YYYY-MM-DD" 형식으로 변환
  const end = new Date(endTime.replace(/\./g, "-"));

  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  // 진행중인지 판단
  let status =
    today < start
      ? "진행전"
      : today >= start && today <= end
      ? "진행중"
      : "기간종료";

  useEffect(() => {
    status =
      today < start
        ? "진행전"
        : today >= start && today <= end
        ? "진행중"
        : "기간종료";
  }, [Date()]);

  return (
    <div
      className="list_contentBar"
      style={{
        gridTemplateColumns:
          "100px 220px 100px 200px 180px 549px 91px 8px 52px",
      }}
    >
      <p className="center">{rownum?.toLocaleString()}</p>
      <p className="leftalign">
        {startTime} ~ {endTime}
      </p>
      <p className="leftalign">{status}</p>
      <p className="leftalign">{step?.toLocaleString()}걸음</p>
      <p className="leftalign">{gifticonCount?.toLocaleString()}개</p>
      <p className="leftalign">{regTime}</p>
      <div className="center">
        <div
          className="blueBorderBtn-58x39 center"
          style={{ width: "91px" }}
          onClick={() => handleClickList(companyChallengeId)}
        >
          발급 내역
        </div>
      </div>
      <div />
      <div className="center">
        <MoreBtn
          option1="수정"
          option2="삭제"
          option1Addr={`/challenge/edit/${companyChallengeId}`}
          optionClickDelete={() => handleClickDelete(companyChallengeId)}
        />
      </div>
    </div>
  );
};

const ChallengeBox = styled.div`
  width: 1500px;
  height: auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  margin-left: 30px;
  margin-top: 30px;
`;

const ChallengeManage = () => {
  return <Layout page={<ChallengeManageContent />} />;
};

export default ChallengeManage;
